import { motion } from "framer-motion";
import BouncyImageTooltip from "./BouncyImageTooltip"; // Assuming this component is ready
// NEW: Import the icons you need
import { FaGithub, FaLinkedin, FaTwitter, FaInstagram } from "react-icons/fa";

// --- Animation Variants (Unchanged) ---
const pageVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1,
    },
  },
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 15,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      ease: "easeOut",
      duration: 0.5,
    },
  },
};

// --- A small, self-contained sidebar component ---
const SocialSidebar = () => {
  return (
    <aside className="social-sidebar">
      <a
        href="https://github.com/mohitxsh"
        target="_blank"
        rel="noreferrer"
        className="social-icon"
        aria-label="GitHub"
      >
        <FaGithub />
      </a>
      <a
        href="https://www.linkedin.com/in/mohitxsh/"
        target="_blank"
        rel="noreferrer"
        className="social-icon"
        aria-label="LinkedIn"
      >
        <FaLinkedin />
      </a>
      <a
        href="https://x.com/mohitxsh"
        target="_blank"
        rel="noreferrer"
        className="social-icon"
        aria-label="Twitter"
      >
        <FaTwitter />
      </a>
      <a
        href="https://www.instagram.com/mohits_93/"
        target="_blank"
        rel="noreferrer"
        className="social-icon"
        aria-label="Instagram"
      >
        <FaInstagram />
      </a>
    </aside>
  );
};

const HomePage = ({ goToPage, onLogoClick }) => {
  const resumeUrl = "https://drive.google.com/file/d/1m0ViaWf0zdyDEsxM64Jn3ObucCB5aYxo/view?usp=sharing";

  const handleLinkClick = (pageIndex) => {
    goToPage(pageIndex);
  };

  const navLinks = [
    { title: "ABOUT ME", pageIndex: 1 },
    { title: "PROFESSIONAL EXPERIENCE", pageIndex: 2 },
    { title: "LET'S CONNECT?", pageIndex: 3 },
  ];

  const name = "Mohit";

  return (
    // NEW: A wrapper to hold the sidebar and main content side-by-side
    <div className="homepage-container">
      <SocialSidebar />
      {/* Your original motion.div now sits next to the sidebar */}
      <motion.div
        className="page home-page"
        variants={pageVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.div className="intro-text" variants={itemVariants}>
          <strong>Hi, I am</strong>
        </motion.div>

        <BouncyImageTooltip>
          <motion.div
            className="logo-main"
            variants={itemVariants}
            onClick={onLogoClick}
          >
            <motion.div
              className="neobrutal-logo"
              variants={itemVariants}
              initial="hidden"
              animate="visible"
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 120, damping: 12 }}
            >
              <span className="logo-text">{name}</span>
              <span className="logo-spark spark-a" aria-hidden="true"></span>
              <span className="logo-spark spark-b" aria-hidden="true"></span>
            </motion.div>
          </motion.div>
        </BouncyImageTooltip>

        <motion.div className="nav-links" variants={itemVariants}>
          {navLinks.map((link) => (
            <button
              key={link.title}
              type="button"
              className="nav-link"
              onClick={() => handleLinkClick(link.pageIndex)}
            >
              {link.title}
            </button>
          ))}
          <a
            href={resumeUrl}
            target="_blank"
            rel="noreferrer"
            className="resume-link"
          >
            VIEW RESUME
          </a>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default HomePage;
